// src/EditorWithUpload.jsx
import React, { useRef } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "../../Components/Common/ClassicEditor";
import { ReactComponent as AttachmentIcon } from "../assets/icons/attachment.svg";
import { ReactComponent as DotIcon } from "../assets/icons/dot.svg";
import commoncss from "../css/common.module.css"

const EditorWithUpload = () => {
  const editorRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const uploadedURL = URL.createObjectURL(file); 

    const editor = editorRef.current;
    editor.model.change((writer) => {
      const insertPosition = editor.model.document.selection.getFirstPosition();
      writer.insertText(file.name, { linkHref: uploadedURL }, insertPosition);
    });
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* File Upload Button */}
      <input
        id="fileInput"
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <span className={`mt-3 mb-2 ${commoncss.clickable}`} onClick={() => document.getElementById("fileInput").click()} style={{color:"#083026ff"}}><AttachmentIcon className={commoncss.vaMiddle} width={18} />&nbsp;Attach files</span>
      
      <CKEditor
        editor={ClassicEditor}
        data="<p>Type here.....</p>"
        onReady={(editor) => {
          editorRef.current = editor;
        }}
        onChange={(event, editor) => {
          console.log("Content:", editor.getData());
        }}
      />
    </div>
  );
};

export default EditorWithUpload;
